import { create } from "zustand";

export enum UnconfirmDirection {
    Registration = "registration",
    LoginAttempt = "login-attempt",
    LoginCreateButton = "login-create-button",
    None = "none",
}

interface RegistrationState {
    registrationEmail: string | null;
    password: string | null;
    isUnconfirmed: UnconfirmDirection | null;
}

interface RegistrationStore {
    registrationData: RegistrationState;
    updateRegistrationData: (updates: Partial<RegistrationState>) => void;
    clearRegistrationData: () => void;
}

export const useRegistrationStore = create<RegistrationStore>((set) => ({
    // Initialize from localStorage
    registrationData: {
        registrationEmail: localStorage.getItem("registrationEmail"),
        password: localStorage.getItem("password"),
        isUnconfirmed: localStorage.getItem("isUnconfirmed") as UnconfirmDirection | null,
    },

    updateRegistrationData: (updates) => {
        set((state) => {
            const updatedData = { ...state.registrationData, ...updates };
            Object.entries(updatedData).forEach(([key, value]) => {
                if (value !== null) {
                    localStorage.setItem(key, value);
                } else {
                    localStorage.removeItem(key);
                }
            });
            return { registrationData: updatedData };
        });
    },

    clearRegistrationData: () => {
        set({
            registrationData: { registrationEmail: null, password: null, isUnconfirmed: null },
        });
        ["registrationEmail", "password", "isUnconfirmed"].forEach((key) => localStorage.removeItem(key));
    },
}));